import * as types from './actionTypes';
import themes from '../config/themeConfig';

export function loadThemeSuccess(theme) {
  return { type: types.LOAD_THEME_SUCCESS, theme };
}

export function loadThemeError(error) {
  return { type: types.LOAD_THEME_ERROR, error };
}

function getUrlParameter(name) {
  // Grab everything after the hash
  const hashQuery = window.location.hash.split('?')[1];
  if (!hashQuery) return null;

  const params = new URLSearchParams(hashQuery);
  return params.get(name);
}

export function loadTheme(organisationGroupId) {
  return function(dispatch) {
    try {
      let themeKey;
      const referrer = getUrlParameter('referrer');
      if (referrer && themes[referrer]) {
        themeKey = referrer;
      }
      else if (organisationGroupId !== undefined) {
        themeKey = organisationGroupId;
      }
      if (!themeKey || !themes[themeKey]) {
        themeKey = 1;
      }
      const theme = themes[themeKey];
      if (!theme) {
        dispatch(loadThemeError(`Theme not found for organisation group: ${organisationGroupId}`));
        return;
      }
      
      // Apply colours
      const root = document.documentElement;
      Object.entries(theme.colours).forEach(([key, value]) => {
        root.style.setProperty(`--${key}-color`, value);
      });

      dispatch(loadThemeSuccess(theme));
    } catch (error) {
      dispatch(loadThemeError(error.message));
    }
  };
}